import React from "react";
import { Card, Container } from "react-bootstrap";
import { BsCircleFill } from "react-icons/bs";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import { Breadcrumb, Col } from 'react-bootstrap';


const TermsConditions = () => {
  const styles = {
    wrapper: {
      padding: "20px",
      backgroundColor: "#f5f6f8",
      minHeight: "100vh",
    },
    card: {
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      backgroundColor: "#ffffff",
    },
    title: {
      fontSize: "16px",
      fontWeight: 600,
      color: "#111827",
      marginBottom: "6px",
    },
    text: {
      fontSize: "14px",
      color: "#4b5563",
      lineHeight: "1.6",
      marginBottom: "8px",
    },
    list: {
      listStyle: "none",
      paddingLeft: 0,
      marginBottom: "12px",
    },
    listItem: {
      display: "flex",
      alignItems: "flex-start",
      fontSize: "14px",
      color: "#4b5563",
      marginBottom: "8px",
    },
    icon: {
      fontSize: "8px",
      marginRight: "8px",
      marginTop: "6px",
      color: "#6b7280",
      flexShrink: 0,
    },
  };

  return (
    <Container fluid style={styles.wrapper}>

       <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Terms & Conditions</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                       Pages

                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Terms & Conditions</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>
      <Card style={styles.card}>
        <Card.Body style={{ paddingBottom: "10px" }}>

          {/* Intro */}
          <div style={{ marginBottom: "16px" }}>
            <p style={styles.text}>
              Welcome to the SilconAdmins platform. These terms and conditions
              outline the rules and regulations for using our administrative
              services. By accessing or using this platform, you agree to comply
              with these terms. Please read them carefully.
            </p>
          </div>

          {/* Acceptance */}
          <div style={{ marginBottom: "16px" }}>
            <h5 style={styles.title}>Acceptance of Terms</h5>
            <p style={styles.text}>
              By using the SilconAdmins platform, you agree to be bound by these
              Terms and Conditions and any additional guidelines, restrictions,
              or rules that may apply to specific sections or services. If you do
              not agree, please do not use this platform.
            </p>
          </div>

          {/* User Responsibilities */}
          <div>
            <h5 style={styles.title}>User Responsibilities</h5>
            <p style={styles.text}>
              As an authorized user of the SilconAdmins platform, you agree to:
            </p>

            <ul style={styles.list}>
              {[
                "Ensure the confidentiality of your login credentials.",
                "Use the platform solely for lawful administrative purposes.",
                "Not share or disclose sensitive employee information unless authorized.",
                "Report any security breaches or suspicious activity immediately.",
              ].map((item, index) => (
                <li key={index} style={styles.listItem}>
                  <BsCircleFill style={styles.icon} />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Platform Usage */}
          <div style={{ marginBottom: "16px" }}>
            <h5 style={styles.title}>Platform Usage</h5>
            <p style={styles.text}>
              The SilconAdmins platform allows you to manage employee data,
              review reports, process payroll, and perform other functions. You
              are responsible for ensuring the accuracy and legality of all
              information entered into the system.
            </p>
          </div>

          {/* Restrictions */}
          <div>
            <h5 style={styles.title}>Restrictions</h5>
            <p style={styles.text}>You agree not to:</p>

            <ul style={styles.list}>
              {[
                "Access the platform for any unlawful purposes.",
                "Use the platform to harass, defraud, or harm any individual or company.",
                "Reverse engineer, decompile, or attempt to extract the source code of the platform.",
                "Interfere with the platform’s functionality or introduce malicious software.",
              ].map((item, index) => (
                <li key={index} style={styles.listItem}>
                  <BsCircleFill style={styles.icon} />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Intellectual Property */}
          <div style={{ marginBottom: "16px" }}>
            <h5 style={styles.title}>Intellectual Property</h5>
            <p style={styles.text}>
              All content, software, and intellectual property associated with
              the platform are owned by SilconAdmins. You may not reproduce,
              distribute, or create derivative works from any materials on the
              platform without prior written consent.
            </p>
          </div>

          {/* Termination */}
          <div style={{ marginBottom: "16px" }}>
            <h5 style={styles.title}>Termination</h5>
            <p style={styles.text}>
              We reserve the right to suspend or terminate your access to the
              platform at any time, without notice, if you violate these terms or
              engage in any unauthorized activity.
            </p>
          </div>

          {/* Disclaimer */}
          <div style={{ marginBottom: "16px" }}>
            <h5 style={styles.title}>Disclaimer of Warranties</h5>
            <p style={styles.text}>
              The SilconAdmins platform is provided on an "as is" and "as available"
              basis. We do not guarantee that the platform will be error-free,
              uninterrupted, or free of security vulnerabilities. We disclaim
              all warranties, express or implied, including but not limited to
              the implied warranties of merchantability, fitness for a
              particular purpose, and non-infringement.
            </p>
          </div>

          {/* Liability */}
          <div style={{ marginBottom: "16px" }}>
            <h5 style={styles.title}>Limitation of Liability</h5>
            <p style={styles.text}>
              In no event shall SilconAdmins be liable for any direct, indirect,
              incidental, special, or consequential damages resulting from the
              use or inability to use the platform, even if we have been advised
              of the possibility of such damages.
            </p>
          </div>

          {/* Modifications */}
          <div style={{ marginBottom: "16px" }}>
            <h5 style={styles.title}>Modifications to Terms</h5>
            <p style={styles.text}>
              We may modify these Terms and Conditions at any time by updating
              this page. Continued use of the platform following any changes
              constitutes acceptance of the revised terms.
            </p>
          </div>

        </Card.Body>
      </Card>
    </Container>
  );
};

export default TermsConditions;